"use client";

import { useState } from "react";

const src = "https://www.google.com/maps?q=Stuttgarter+Str.+19,+70794+Filderstadt&hl=de&z=15&output=embed";

// Google map behind a click: nothing is sent to Google before the visitor asks for the map.
export default function MapEmbed() {
  const [on, setOn] = useState(false);
  if (on) {
    return (
      <iframe
        src={src}
        title="Karte: Polsterei ideensprung, Stuttgarter Str. 19, Filderstadt"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className="block h-[300px] w-full rounded-xl border-0"
      />
    );
  }
  return (
    <div className="ph flex h-[300px] flex-col items-center justify-center gap-3 rounded-xl p-6 text-center">
      <button
        type="button"
        onClick={() => setOn(true)}
        className="min-h-11 cursor-pointer rounded-full bg-accent-fill px-6 py-3 font-semibold text-white"
      >
        Karte von Google laden
      </button>
      <p className="m-0 max-w-[36ch] rounded bg-bg/85 px-2.5 py-1 text-[13px] text-ink-2">
        Beim Laden werden Daten (z. B. Ihre IP-Adresse) an Google übertragen.
      </p>
    </div>
  );
}
